// extracted by mini-css-extract-plugin
export default {"filterWrapper":"FilterBar_filterWrapper__JshsS","multi_chip":"FilterBar_multi_chip__zSRw4"};